<div class="risk">
  <span class="fs-16 fw-600 mbl semi-bold">{{ title }}</span>
  <div class="ea-options-container ea-risk-options-container">
    @for (item of _.range(0, 7); track item) {
      <span [ngClass]="{ inactive: !indexIsInRange(item + 1) }">{{
        item + 1
      }}</span>
    }
  </div>
</div>
